<div class="app-splash-screen"
     [ngStyle]="{ left: windowWidth }"
     *ngIf="showSplash">
  <!--<div class="app-logo">-->
    <!--<div class="app-logo"></div>-->
    <!--<div class="app-label">Orange</div>-->
    <div class="row app-loader"></div>
  <!--</div>-->
</div>
